export enum CompanyStatus {
  'active' = 0,
  'strike-off' = 1,
  'deregistered' = 2,
  'administration' = 3,
  'archived' = 4,
  'non-agent' = 5,
}
 
// export enum CompanyStatus {
//     Registered,
//     Deregistering,
//     Deregistered,
//     Administration,
//     External
// }

export enum CompanyType {
  LMSH, // Limited by shares
  NLIA, // No liability
  UNLM, // Unlimited
  LMGT, // Limited by guarantee
  LMSG  // Limited by shares and guarantee
}

export enum CompanySubtype {
  PNPC, // Proprietary non-profit
  PSTC, // Proprietary SMSF trustee
  HUNT, // Proprietary home unit company
  PROP, // Proprietary other company
  LISN, // Section 383 company
  LISS, // Superannuation trustee company
  LIST, // Listed public company
  STFI, // Small transferring financial institutions
  NLTD, // Not limited public company (section 150)
  ULSN, // Unlisted public non-profit company
  ULSS, // Unlisted superannuation trustee
  ULST  // Unlisted public
}

export const CompanyTypeLabels: Record<CompanyType, string> = {
  [CompanyType.LMSH]: 'Limited by shares',
  [CompanyType.NLIA]: 'No liability',
  [CompanyType.UNLM]: 'Unlimited',
  [CompanyType.LMGT]: 'Limited by guarantee',
  [CompanyType.LMSG]: 'Limited by shares and guarantee',
};
export const CompanySubtypeLabels: Record<CompanySubtype, string> = {
  [CompanySubtype.PNPC]: 'Proprietary - non-profit company',
  [CompanySubtype.PSTC]: 'Proprietary - superannuation trustee company',
  [CompanySubtype.HUNT]: 'Proprietary - home unit company',
  [CompanySubtype.PROP]: 'Proprietary other company',
  [CompanySubtype.LISN]: 'Section 383 company',
  [CompanySubtype.LISS]: 'Superannuation trustee company',
  [CompanySubtype.LIST]: 'Listed public company',
  [CompanySubtype.STFI]: 'Small transferring financial institutions',
  [CompanySubtype.NLTD]: 'Not limited public company (section 150)',
  [CompanySubtype.ULSN]: 'Unlisted public non-profit company',
  [CompanySubtype.ULSS]: 'Unlisted superannuation trustee',
  [CompanySubtype.ULST]: 'Unlisted public',
};
